<template>
    <div className="home">
        <UploadData/>
    </div>
</template>

<script>
// @ is an alias to /src
import UploadData from '@/components/UploadData.vue'

export default {
    name: 'UploadView',
    components: {
        UploadData
    }
}
</script>
